<template>
  <v-form ref="form" v-model="valid">
    <v-text-field
      v-model="form.name"
      label="Name"
      :rules="[rules.required]"
      dense
      outlined
    ></v-text-field>
    <v-text-field
      v-model="form.email"
      label="Email"
      :rules="[rules.required, rules.emailMatch]"
      dense
      outlined
    ></v-text-field>
    <v-textarea
      v-model="form.message"
      dense
      label="Your Message"
      auto-grow
      outlined
      :rules="[rules.required]"
      rows="8"
      row-height="20"
    ></v-textarea>
    <v-btn
      outlined
      block
      :loading="loading"
      :disabled="loading"
      color="primary"
      @click="submit"
      >SEND MESSAGE</v-btn
    >
    {{ response }}
  </v-form>
</template>
<script>
import cl from "@/services/contactUs";

export default {
  data() {
    return {
      loading: false,
      valid: true,
      response: "",

      form: {},
      rules: {
        emailMatch: (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
        required: (value) => !!value || "Field required",
      },
    };
  },
  mounted() {},
  methods: {
    async fetchSomething() {
      this.loading = true;
      cl.add(this.form)
        .then((res) => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: res },
            { root: true }
          );
        })
        .catch((e) => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: e },
            { root: true }
          );
        });
    },
    submit() {
      this.$refs.form.validate();
      // if (this.valid === false)
      //  console.log(true)
      this.fetchSomething();
    },
  },
};
</script>
